module.exports = __webpack_public_path__ + "static/media/beer.80efbdde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/beer.jpg
// module id = 119
// module chunks = 0